export default __webpack_public_path__ + "static/media/faqArrow.5566c87c.svg";